// Editörde (.ProseMirror) alıntının ilk eşleşmesini seçip ortaya kaydırır.
// Eşleşme yoksa false döner (çağıran "bulunamadı" davranışını seçer).
export function locateExcerptInEditor(excerpt: string): boolean {
  const el = document.querySelector(".ProseMirror");
  if (!(el instanceof HTMLElement) || !excerpt) return false;
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  let node: Node | null = walker.nextNode();
  while (node) {
    const idx = node.textContent?.indexOf(excerpt) ?? -1;
    if (idx >= 0) {
      const range = document.createRange();
      range.setStart(node, idx);
      range.setEnd(node, idx + excerpt.length);
      const sel = window.getSelection();
      sel?.removeAllRanges();
      sel?.addRange(range);
      (node.parentElement ?? el).scrollIntoView({ block: "center", behavior: "smooth" });
      return true;
    }
    node = walker.nextNode();
  }
  return false;
}
